<div class="nl-wrap">

  <div class="nl-header">
    <div>
      <h2 class="nl-header__title">Newsletter — Campañas</h2>
    </div>
    <div class="nl-header__actions">
      <button mat-stroked-button (click)="goToTemplates()">
        <mat-icon>description</mat-icon> Plantillas
      </button>
      <button mat-flat-button color="primary" (click)="goToNew()">
        <mat-icon>add</mat-icon> Nueva campaña
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="nl-state">
    <div class="nl-spinner"></div>
    <span>Cargando campañas...</span>
  </div>

  <div *ngIf="errorMessage" class="nl-error">{{ errorMessage }}</div>

  <div *ngIf="!loading && campaigns.length === 0 && !errorMessage" class="nl-empty">
    <mat-icon class="nl-empty__icon">mail_outline</mat-icon>
    <p>Aún no hay campañas. Crea la primera para empezar.</p>
    <button mat-flat-button color="primary" (click)="goToNew()">Crear campaña</button>
  </div>

  <div *ngIf="!loading && campaigns.length > 0" class="nl-card">
    <table class="nl-table">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Asunto</th>
          <th>Estado</th>
          <th>Destinatarios</th>
          <th>Enviados</th>
          <th>Fallidos</th>
          <th>Programada</th>
          <th class="nl-table__actions-col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of campaigns" class="nl-table__row" (click)="goToDetail(c.id)">
          <td class="nl-table__name">{{ c.name }}</td>
          <td class="nl-table__truncate">{{ c.subject }}</td>
          <td>
            <span class="nl-badge" [ngClass]="statusClass(c.status)">{{ statusLabel(c.status) }}</span>
          </td>
          <td>{{ c.totalRecipients }}</td>
          <td>{{ c.sentCount }}</td>
          <td [class.nl-table__failed]="c.failedCount > 0">{{ c.failedCount }}</td>
          <td class="nl-table__date">{{ c.scheduledAt ? (c.scheduledAt | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
          <td class="nl-table__actions-col" (click)="$event.stopPropagation()">
            <button *ngIf="c.status === 'DRAFT'" mat-icon-button color="primary"
                    (click)="goToEdit($event, c.id)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="c.status === 'SCHEDULED'" mat-icon-button color="warn"
                    (click)="cancelCampaign($event, c.id)" matTooltip="Cancelar programación">
              <mat-icon>cancel</mat-icon>
            </button>
            <button *ngIf="c.status === 'DRAFT' || c.status === 'CANCELLED'"
                    mat-icon-button color="warn"
                    (click)="deleteCampaign($event, c.id)" matTooltip="Eliminar">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
